// frontend/src/components/Authentication/AxiosInstance.js
import axios from 'axios';
import { getAccessToken, getRefreshToken, refreshToken } from './auth';

const apiKey = process.env.REACT_APP_API_KEY
const apiBase = process.env.REACT_APP_API_ENDPOINT
const predictorBase = process.env.REACT_APP_PREDICTOR_ENDPOINT || process.env.REACT_APP_API_ENDPOINT
console.log(apiKey, apiBase, predictorBase);
// Request Interceptor
const attachAuthInterceptor = (instance, options = {}) => {
  instance.interceptors.request.use(
    async (config) => {
      const token = getAccessToken();
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );


  // Response Interceptor (for refreshing the token)
  instance.interceptors.response.use(
    (response) => response,  // If the response is successful, just return it
    async (error) => {
      const originalRequest = error.config;
      // If 401 and request hasn't been retried
      if (error.response && error.response.status === 401 && !originalRequest._retry &&  getRefreshToken()) {
          originalRequest._retry = true;
        // Handle token expiration or removal here
        try {
          const tokenResponse = await refreshToken();
          const newAccessToken = tokenResponse.data.access;
          // Update header and retry original request
          originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
          return checkToken(originalRequest);
        } catch (refreshError) {
          // Refresh token failed: logout user
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          return Promise.reject(refreshError);
        }
      } 
      return Promise.reject(error);
    }
  );
}
const checkApi = axios.create({
  baseURL: apiBase,
  headers: {
    ...(apiKey && { 'X-API-KEY': apiKey }),
  },
});
attachAuthInterceptor(checkApi);
// Create an Axios instance
const checkPredictors = axios.create({
  baseURL: predictorBase,
  headers: { 'Content-Type': 'application/json' },
});
attachAuthInterceptor(checkPredictors);

// Create an Axios instance
const checkToken = axios.create({
  baseURL: apiBase,
  headers: { 'Content-Type': 'application/json' },
});

attachAuthInterceptor(checkToken);
export {checkToken, checkApi, checkPredictors};
